import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { useSelector, useDispatch } from "react-redux";
import {
    updateSentMessage,
    fetchMessageResponse,
    statusUpdate,unReadCountUpdate,
} from "../../features/messages/messagesSlice";
import { setAddNewWaContact } from "../../features/contact/contactSlice";

export function SocketProvider() {
    const { user } = useSelector((state) => state.authentication);
    const client_id = user?.client_id;
    const dispatch = useDispatch();
    const { selectedUser } = useSelector((state) => state.messages);
  
    // Use ref to store socket instance
    const socketRef = useRef(null);

    useEffect(() => {
        if (!client_id) return; // Don't connect if not logged in

        // Create socket only when client_id exists
        if (!socketRef.current) {
            socketRef.current = io("https://wapi.rizee.in");
        }

        const socket = socketRef.current;

        // Connect and register
        socket.on("connect", () => {
            console.log("🟢 Connected:", socket.id);
            socket.emit("register", { client_id });
        });

        socket.on("disconnect", (reason) => {
            console.log("🔴 Disconnected:", reason);
        });

        socket.on("message", (data) => {
            console.log("📩 New message:", data);
            dispatch(updateSentMessage(data));
        });

        socket.on("new_message_inserted", (val, data) => {
            console.log("✅ Message inserted:", val, data);
            dispatch(fetchMessageResponse({ val, data }));
        });

        socket.on("updatedStatus", (data) => {
            console.log("🔄 Status update:", data);
            dispatch(statusUpdate(data));
        });

        socket.on("contact", (waContact) => {
            console.log("🟢 New contact:", waContact);
            dispatch(setAddNewWaContact(waContact));
            dispatch(unReadCountUpdate(waContact))
        });

        return () => {
            socket.off("connect");
            socket.off("disconnect");
            socket.off("new_message");
            socket.off("new_message_inserted");
            socket.off("updatedStatus");
            socket.off("contact");
        };
    }, [client_id, dispatch]);

    return null;
}
